import type { DropdownItem } from '@gr-monorepo/common/public/ui'

export type OlympiadEducationYear = [string, string]

export type OlympiadEducationYearOption = DropdownItem & {
  year: OlympiadEducationYear
}

export const olympiadEducationYears: readonly OlympiadEducationYear[] = [
  ['2026', '2027'],
  ['2025', '2026'],
  ['2024', '2025'],
  ['2023', '2024'],
  ['2022', '2023'],
  ['2021', '2022'],
  ['2020', '2021'],
]

const formatYearLabel = (year: OlympiadEducationYear) => `${year[0]}/${year[1].slice(-2)}`

export const olympiadEducationYearOptions: readonly OlympiadEducationYearOption[] =
  olympiadEducationYears.map((year) => {
    const label = formatYearLabel(year)

    return {
      year,
      label,
      value: label,
    }
  })

export const DASHBOARD_STATISTIC_YEAR_THRESHOLD = '2026'
export const CURRENT_EDUCATION_YEARS: OlympiadEducationYear = ['2026', '2027']
export const STATISTICS_UNAVAILABLE_EDUCATION_YEARS: OlympiadEducationYear = ['2027', '2028']

export const isOlympiadStatisticsUnavailableYear = (year: OlympiadEducationYear) =>
  year[0] === STATISTICS_UNAVAILABLE_EDUCATION_YEARS[0]

export const SELECTED_OLYMPIAD_YEAR_STORAGE_KEY = 'olympiads_selected_year'

const findOlympiadEducationYear = (storedYear: readonly string[]) =>
  olympiadEducationYears.find((year) => year[0] === storedYear[0])

export const readSelectedOlympiadYear = (): OlympiadEducationYear => {
  try {
    const storedYear = sessionStorage.getItem(SELECTED_OLYMPIAD_YEAR_STORAGE_KEY)
    if (!storedYear) {
      return CURRENT_EDUCATION_YEARS
    }

    const parsedYear = JSON.parse(storedYear) as OlympiadEducationYear
    return findOlympiadEducationYear(parsedYear) ?? CURRENT_EDUCATION_YEARS
  } catch {
    return CURRENT_EDUCATION_YEARS
  }
}

export const saveSelectedOlympiadYear = (year: OlympiadEducationYear) => {
  sessionStorage.setItem(SELECTED_OLYMPIAD_YEAR_STORAGE_KEY, JSON.stringify(year))
}

export const isTableStatisticYear = (year: OlympiadEducationYear) =>
  year[0] < DASHBOARD_STATISTIC_YEAR_THRESHOLD

export const toYearLearn = (year: OlympiadEducationYear) => `${year[0]}/${year[1]}`

export const getOlympiadEducationYearOption = (year: OlympiadEducationYear) =>
  olympiadEducationYearOptions.find((option) => option.year[0] === year[0]) ??
  olympiadEducationYearOptions.find((option) => option.year[0] === CURRENT_EDUCATION_YEARS[0])!
